var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramUtilityNonMains64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./UtilityNonMains64*",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "UnPlugged",
    transform: "translate(4.000000, 17.000000)",
    stroke: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5,15 C19.9846491,17.8990377 17.4846491,18.8990377 14,18 C8.77302641,16.6514434 9.91271973,11 5.99609375,11 C3.38500977,11 1.38631185,13.3333333 0,18",
    id: "cable",
    strokeWidth: 2,
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,29 C33.278852,29 34.278852,29 34,29 L34,1 C32.8748419,1 31.8748419,1 31,1 C27.581722,1 22,4.2680135 22,15 C22,25.7319865 27.581722,29 31,29 Z",
    id: "Focus",
    strokeWidth: 2,
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 34,
    y: 1,
    width: 11,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bottom",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 44.5,
    y: 21.5,
    width: 7,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "top",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 44.5,
    y: 7.5,
    width: 7,
    height: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramUtilityNonMains64);
export default __webpack_public_path__ + "static/media/pictogramUtilityNonMains64.c052209cb6f7561473d8109ae99169dd.svg";
export { ForwardRef as ReactComponent };